import fetchExpresso from 'utility/fetchExpresso';

import type { ReportView } from './reportViewTypes';

export type ReportViewsResponse = {
    views: ReportView[];
};

export async function fetchReportViews(eventId: number): Promise<ReportViewsResponse> {
    const res = await fetchExpresso(`/apiv2/events/${eventId}/report-views`);

    if (!res.ok) {
        throw new Error('Failed to load report views');
    }

    return (await res.json()) as ReportViewsResponse;
}
